
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVesselTypeFishingOutlined as ObiVesselTypeFishingOutlinedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-vessel-type-fishing-outlined.js';
 
 
 

 
 export const ObiVesselTypeFishingOutlined = createComponent({
   react: React,
   tagName: 'obi-vessel-type-fishing-outlined',
   elementClass: ObiVesselTypeFishingOutlinedElement,
   events: {
     
   }
  });
 
 